module.exports = __webpack_public_path__ + "img/icon-search.1ede55a3.svg";